module.exports = __webpack_public_path__ + "static/media/mobile-services-project-bg-1.dd49eb50.svg";